import { QuoteModel } from '../model';
import { createStore, withProps, select } from '@ngneat/elf';
import { filter } from 'rxjs/operators';

export interface QuoteState extends QuoteModel {
  loading: boolean;
}

const store = createStore(
  { name: 'quote' },
  withProps<QuoteState>({ loading: false } as QuoteState)
);

const quoteLoaded$ = store.pipe(
  select((state) => state),
  filter((state) =>
    state.rooms ? state.rooms && !!state.rooms.length && !state.loading : false
  )
);

const quoteIsLoading$ = store.pipe(select((state) => state.loading));

const setLoading = (loading: boolean) =>
  store.update((state) => ({ ...state, loading }));

const updateQuote = (quote: QuoteModel) =>
  store.update((state) => ({ ...state, ...quote }));

export const QuoteRepository = {
  store,
  quoteIsLoading$,
  quoteLoaded$,
  updateQuote,
  setLoading,
};
